module.exports = __webpack_public_path__ + "img/comp51-bg-house.61b54d54.png";